import { useNavigate } from "react-router-dom";
import ModelExplanationGrid from "./ModelExplanationGrid";


const WelcomeDashboard = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/dashboard/data-entry");
  };


  return (
    <>
      {/* {data?.processed_files.length === 0 ? (
        <>
          <ModelExplanationGrid handleGetStarted={handleGetStarted} />
        </>
      ) : (
        <UserHistoryDashboard data={data} handleGetStarted={handleGetStarted} loading={loading} />
      )} */}
       <ModelExplanationGrid handleGetStarted={handleGetStarted} />
    </>
  );
};


export default WelcomeDashboard;